import { createFileRoute, Link } from "@tanstack/react-router";
import type { ContradictionPair } from "@/api/types";
import contradictions from "@/fixtures/contradictions.json";
import { ContradictionPane } from "@/components/contradiction/ContradictionPane";

const PAIRS = contradictions as Record<string, ContradictionPair>;

export const Route = createFileRoute("/contradictions/$contradictionId")({
  component: ContradictionPanePage,
});

function ContradictionPanePage() {
  const { contradictionId } = Route.useParams();
  const pair = PAIRS[contradictionId];

  if (!pair) {
    return (
      <div className="mx-auto max-w-3xl px-6 py-16 text-center">
        <p className="text-caps uppercase tracking-caps text-ink-tertiary">Not found</p>
        <h1 className="mt-3 font-serif text-display text-ink-primary">
          No contradiction “{contradictionId}”
        </h1>
        <Link
          to="/contradictions"
          className="mt-6 inline-block text-meta text-ink-info hover:text-ink-primary"
        >
          ← All contradictions
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl px-6 py-10 lg:px-10">
      <ContradictionPane pair={pair} />
    </div>
  );
}
